<template>
    <div>
        <b-row>
            <b-col md="6" class="my-1">
                <h3 class="text-themecolor">Dashboard</h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                <div class="card">
                    <div class="card-body">
                        <h4>Aantal onbekende documenten: <b>{{counts.onbekendeDocumenten}}</b></h4>
                        <PreLoader v-if="busy"/>
                        <router-link :to="{ name: 'documents:index' }" class="btn btn-success" aria-expanded="false">
                                {{$t('sidebar.onbekendedocumenten')}}
                        </router-link>
                    </div>
                </div>
            </b-col>
            <b-col md="4">
                <div class="card">
                    <div class="card-body">
                        <h4>Aantal triggermeldingen: <b>{{counts.triggerMeldingen}}</b></h4>
                        <PreLoader v-if="busy"/>
                        <router-link :to="{ name: 'triggermeldingen:index' }" class="btn btn-success" aria-expanded="false">
                                    {{$t('sidebar.triggermeldingen')}}
                        </router-link>
                    </div>
                </div>
            </b-col>
            <b-col md="4">
                <div class="card">
                    <div class="card-body">
                        <h4>Aantal feedbackmeldingen: <b>{{counts.feedbackMeldingen}}</b></h4>
                        <PreLoader v-if="busy"/>
                        <router-link :to="{ name: 'feedback:index' }" class="btn btn-success" aria-expanded="false">
                                    {{$t('sidebar.feedback')}}
                        </router-link>
                    </div>
                </div>
            </b-col>
        </b-row>
        
    </div>
    </template>
    <script>
    //Import store
    import { mapActions } from 'vuex'
    import PreLoader from '@/components/root/Preloader';

    export default {
        name: `dashboard-index`,
        components: {PreLoader},
        data() {
            return {
                counts: {},
                busy: true,
            }
        },
        methods: {
            ...mapActions('fmmodule', ['all','executeCommand']),
    
        },
        created() {
            let vm = this;
            
            vm.all({
                resource: 'dashboard',
                cacheResult: false
            })
            .then((data) => {
                this.counts = data.result.counts;
                this.busy = false
            });
        }
    }
    
    </script>
    <style>
    .btn-success, .btn-success.disabled {
        color: white !important;
    }
    </style>
    